var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    { attrs: { value: _vm.value, persistent: "", width: "600" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            { attrs: { flat: "", dark: "", color: "#00aff0" } },
            [
              _c("v-toolbar-title", [_vm._v(_vm._s(_vm.attr.name))]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("update:value", false)
                    }
                  }
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _vm._l(_vm.getLayout(), function(row, index) {
            return _c(
              "v-row",
              { key: index, staticClass: "mx-3", attrs: { dense: "" } },
              _vm._l(row, function(item) {
                return _c(
                  "v-col",
                  { key: item.id, attrs: { cols: "3" } },
                  [
                    _c(
                      "v-layout",
                      [
                        _c("v-checkbox", {
                          staticClass: "my-1",
                          attrs: {
                            label: item.name,
                            value: _vm.getValue(item)
                          },
                          on: {
                            change: function(event) {
                              return _vm.handleToggle(event, item)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              1
            )
          }),
          _c("v-divider"),
          _c(
            "v-card-actions",
            { staticClass: "grey lighten-3" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { width: "100", color: "error" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("update:value", false)
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { width: "100", color: "success" },
                  on: { click: _vm.saveValues }
                },
                [_vm._v("Save")]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }